import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios, { axiosEnrollmentAppApi } from '../../../../axios.js';
import {
  GET_CUSTOMER_CURRENT_PLAN,
  GET_PAYMENT_DETAILS,
  GET_ACCOUNTS_DETAILS,
  GET_CUSTOMER_CURRENT_PLAN_ADDONS,
  GET_USER_COMMUNITY_PLANS,
  USER_PLAN_CHANGES,
  GET_CENTRIC_SEARCH_USER,
  GET_CENTRIC_CUSTOMER_SEARCH_USER,
  FIBER_CONNECTION_DETAILS,
  USER_PLAN_ADD_ONS,
  GET_USER_VOIP_COMMUNITY_PLANS,
  GET_USER_TV_COMMUNITY_PLANS,
  INTERNAL_USER_LIST,
  GET_CENTRIC_SEARCH_USER_BY_PHONE
  //GET_USER_TV_PLANS
} from '../../../../Urls.js';
import { ServiceGroupType } from '../../../../features/constants/commonEnum.js';

const dummyPaymentData = {
  unpaidBalance: '$110.80',
  paimentDue: 'Mar 22',
  autoPayDate: 'Mar 21',
  autoPayEnabled: false
};

const initialState = {
  userAccountDetails: { userLoginInfo: null, userAccountInfo: [], loader: false, error: null },
  selectedServiceGroupType: ServiceGroupType.FIBER,
  selectedAccount: null,
  selectedAddressAccount: null,
  selectedAddressServiceAccount: null,
  getCurrentPlanData: { data: [], loader: false },
  getCurrentPlanAddonsData: { data: [], loader: false },
  getCurrentPayamentData: { data: {}, loader: false },
  getServiceTypePayamentData: { data: null, loader: false },
  getAccountsDetailData: { data: [], loader: false },
  getUserPlanChangeData: { data: [], loader: false },
  getUserPlanAddOnsChangeData: { data: [], loader: false },
  getUserCommunityPlansData: { data: [], loader: false },
  getUserCommunityVoipPlansData: { data: [], loader: false },
  getUserCommunityTvPlansData: { data: [], loader: false },
  getCentricUserLogin: false,
  fiberConnectionDetails: { data: {}, loader: false },
  internalUserDeatails: { data: {}, loader: false },
  phoneSearchedUserData: { data: [], loader: false, error: null },
  tempDetails: {
    userName: "",
    password: ""
  }
};

export const FiberConnectionDetails = createAsyncThunk(
  'app/get/fiberConnectionDetais',
  async (reqData) => {
    const response = await axios.get(FIBER_CONNECTION_DETAILS + "?premise_id=" + reqData.premise_id, { ...reqData });
    return response;
  }
);
export const getinternalUserDeatails = createAsyncThunk(
  "app/get/internalUserDetails",
  async (payload) => {
    const response = await axios.get(INTERNAL_USER_LIST, {
      params: payload,
    });
    return response;
  },
);

export const UpdateUserPlanChange = createAsyncThunk(
  'app/get/updatePlanChangeData',
  async (reqData) => {
    const response = await axios.post(USER_PLAN_CHANGES, { ...reqData });
    return response;
  }
);

export const UpdateUserPlanAddOns = createAsyncThunk(
  'app/get/updatePlanAddons',
  async (reqData) => {
    const response = await axios.post(USER_PLAN_ADD_ONS, { ...reqData });
    return response;
  }
);

export const getUserCommunityPlans = createAsyncThunk(
  'app/get/getCommunityPlansData',
  async (reqData) => {
    const response = await axiosEnrollmentAppApi.get(GET_USER_COMMUNITY_PLANS + `/${reqData.gas_fiber}?community_name=${reqData.community_name}&customer_type=${reqData.customer_type}&region=${reqData.region}&gas_fiber=${reqData.gas_fiber}&jurisdiction=null&customer_sub_type=null`);
    return response;
  }
);

export const getUserVoipCommunityPlans = createAsyncThunk(
  'app/get/getCommunityVoipPlansData',
  async (reqData) => {
    //const response = await axios.post(GET_USER_COMMUNITY_PLANS, { ...reqData });
    const response = await axiosEnrollmentAppApi.get(GET_USER_VOIP_COMMUNITY_PLANS + `?community_name=${reqData.communityName}&customer_type=${reqData.customerType}&region=${reqData.region}&fiberOpted=${reqData.fiberOpt}&customer_sub_type=null`);
    return response;
  }
);

export const getUserTvCommunityPlans = createAsyncThunk(
  'app/get/getCommunityTvPlansData',
  async (reqData) => {
    //const response = await axios.post(GET_USER_COMMUNITY_PLANS, { ...reqData });
    const response = await axiosEnrollmentAppApi.get(GET_USER_TV_COMMUNITY_PLANS + `?community_name=${reqData.community_name}`);
    return response;
  }
);

export const getCurrentPlan = createAsyncThunk(
  'app/get/getPlanData',
  async ({ crmServiceAccountId, service_type }) => {
    const response = await axios.get(
      GET_CUSTOMER_CURRENT_PLAN + crmServiceAccountId + '&service_type=' + service_type
    );
    return response;
  }
);

export const getCurrentPlanAddons = createAsyncThunk(
  'app/get/getCurrentPlanAddons',
  async ({ crmServiceAccountId, service_type }) => {
    const response = await axios.get(
      GET_CUSTOMER_CURRENT_PLAN_ADDONS + crmServiceAccountId + '&service_type=' + service_type
    );
    return response;
  }
);

export const getPayementDetails = createAsyncThunk(
  'app/get/getPaymenteData',
  async ({ serviceAccId, billing_account_number }) => {
    const response = await axios.post(GET_PAYMENT_DETAILS, {
      crm_service_account_no: serviceAccId,
      crm_billing_account_no: billing_account_number
    });
    return response;
  }
);

export const getServiceTypePayementDetails = createAsyncThunk(
  'app/get/getServcieTypePaymenteData',
  async ({ service_type, serviceAccId, billing_account_number }) => {
    const response = await axios.post(GET_PAYMENT_DETAILS, {
      service_type: service_type,
      service_account_id: serviceAccId,
      billing_group_id: billing_account_number
    });
    return response;
  }
);

export const setautoPayData = createAsyncThunk('app/get/setAutoPay', async () => {
  const response = await axios.get(`/api/v1/setAutoPAy`);
  return response;
});

export const getAccountDetails = createAsyncThunk('app/get/getAccounts', async userId => {
  const resAccounts = await axios.get(GET_ACCOUNTS_DETAILS + userId);
  return resAccounts;
});

export const getSearchPrimseAccountDetails = createAsyncThunk(
  'app/get/getCentricSearchAccounts',
  async addressOremailOrPhone => {
    const resAccounts = await axios.get(GET_CENTRIC_SEARCH_USER + addressOremailOrPhone);
    return resAccounts;
  }
);

// search by address, email and phone number
export const getAccountDetailsByPhonenumber = createAsyncThunk(
  'app/get/getAccountsByPhone',
  async phone => {
    if (!phone) return { data: { "is-success": false, messages: [""] } };
    const resuserAccounts = await axios.get(GET_CENTRIC_SEARCH_USER_BY_PHONE + phone);
    return resuserAccounts;
  }
);

export const searchByAddressEmailPhoenumber = createAsyncThunk(
  'app/get/getAddressUserDetails',
  async ({ address, email, phone, isActive }) => {
    let query = '';

    if (address && address !== '') {
      query = GET_CENTRIC_CUSTOMER_SEARCH_USER + `?address=${address}&ActiveAccount=${isActive}`;
    }

    if (email && email !== '') {
      if (query === '') {
        query = GET_CENTRIC_CUSTOMER_SEARCH_USER + `?email=${email}&ActiveAccount=${isActive}`;
      } else {
        query = query + `&email=${email}`;
      }
    }

    if (phone && phone !== '') {
      if (query === '') {
        query = GET_CENTRIC_CUSTOMER_SEARCH_USER + `?phone=${phone}&ActiveAccount=${isActive}`;
      } else {
        query = query + `&phone=${phone}`;
      }
    }

    const resAccounts = await axios.get(query);
    if (!resAccounts?.data?.["is-success"]) {
    }
    return resAccounts;
  }
);

export const userDetailSlice = createSlice({
  name: 'app/userDetailSlice',
  initialState,
  reducers: {
    updateFiberPlanData: (state, action) => {
      state.getUserCommunityPlansData.data = action?.payload;
    },
    updateVoipPlanData: (state, action) => {
      state.getUserCommunityVoipPlansData.data = action?.payload;
    },
    updateTvPlanData: (state, action) => {
      state.getUserCommunityTvPlansData.data = action?.payload;
    },
    setSelectedAccount: (state, action) => {
      state.selectedAccount = action?.payload;
    },
    setSelectedAddressAccount: (state, action) => {
      state.selectedAddressAccount = action?.payload;
    },
    setSelectedAddressServiceAccount: (state, action) => {
      state.selectedAddressServiceAccount = action?.payload;
    },
    setSelectedServiceGroupType: (state, action) => {
      state.selectedServiceGroupType = action?.payload;
    },
    setUserLoginInfo: (state, action) => {
      state.userAccountDetails.userLoginInfo = action?.payload;
    },
    setUserAccountDetails: (state, action) => {
      state.userAccountDetails.userAccountInfo = action?.payload;
    },
    setCentricUser: (state, action) => {
      state.getCentricUserLogin = action?.payload;
    },
    updateTempUserData: (state, action) => {
      state.tempDetails = action?.payload;
    },
    clearErrorMessage: (state) => {
      state.userAccountDetails = { ...state.userAccountDetails, error: null };
    }
  },

  extraReducers: builder => {
    builder

      // User Account Details
      .addCase(searchByAddressEmailPhoenumber.pending, state => {
        state.userAccountDetails.loader = true;
      })
      .addCase(searchByAddressEmailPhoenumber.fulfilled, (state, action) => {
        state.userAccountDetails.loader = false;
        state.userAccountDetails.userAccountInfo = action?.payload?.data?.["is-success"] ? action?.payload?.data?.data?.[0] : [];
        state.userAccountDetails.error = action?.payload?.data?.["is-success"] ? null : action?.payload?.data?.messages?.[0];
      })
      .addCase(searchByAddressEmailPhoenumber.rejected, state => {
        state.userAccountDetails.loader = false;
        state.userAccountDetails.error = "An error occurred while searching for user details.";
      })

      // Plan
      .addCase(getCurrentPlan.pending, state => {
        state.getCurrentPlanData.loader = true;
      })
      .addCase(getCurrentPlan.fulfilled, (state, action) => {
        state.getCurrentPlanData.loader = false;
        state.getCurrentPlanData.data = action?.payload?.data?.data;
      })
      .addCase(getCurrentPlan.rejected, state => {
        state.getCurrentPlanData.loader = false;
      })

      // AddOns
      .addCase(getCurrentPlanAddons.pending, state => {
        state.getCurrentPlanAddonsData.loader = true;
      })
      .addCase(getCurrentPlanAddons.fulfilled, (state, action) => {
        state.getCurrentPlanAddonsData.loader = false;
        state.getCurrentPlanAddonsData.data = action?.payload?.data?.data;
      })
      .addCase(getCurrentPlanAddons.rejected, state => {
        state.getCurrentPlanAddonsData.loader = false;
      })

      .addCase(getPayementDetails.pending, state => {
        state.getCurrentPayamentData.loader = true;
      })
      .addCase(getPayementDetails.fulfilled, (state, action) => {
        state.getCurrentPayamentData.loader = false;
        state.getCurrentPayamentData.data = action?.payload?.data?.data;
      })
      .addCase(getPayementDetails.rejected, state => {
        state.getCurrentPayamentData.loader = false;
        state.getCurrentPayamentData.data = {};
      })

      // Service type payment
      .addCase(getServiceTypePayementDetails.pending, state => {
        state.getServiceTypePayamentData.loader = true;
      })
      .addCase(getServiceTypePayementDetails.fulfilled, (state, action) => {
        state.getServiceTypePayamentData.loader = false;
        state.getServiceTypePayamentData.data = action?.payload?.data?.data || dummyPaymentData;
      })
      .addCase(getServiceTypePayementDetails.rejected, state => {
        state.getServiceTypePayamentData.loader = false;
        state.getServiceTypePayamentData.data = dummyPaymentData;
      })

      .addCase(setautoPayData.pending, state => {
        state.getCurrentPayamentData.loader = true;
      })
      .addCase(setautoPayData.fulfilled, state => {
        state.getCurrentPayamentData.loader = false;
        state.getCurrentPayamentData.data.autoPayEnabled =
          !state.getCurrentPayamentData.data.autoPayEnabled;
      })
      .addCase(setautoPayData.rejected, state => {
        state.getCurrentPayamentData.loader = false;
        state.getCurrentPayamentData.data.autoPayEnabled =
          !state.getCurrentPayamentData.data.autoPayEnabled;
      })

      .addCase(getAccountDetails.pending, state => {
        state.getAccountsDetailData.loader = true;
      })
      .addCase(getAccountDetails.fulfilled, (state, action) => {
        state.getAccountsDetailData.loader = false;
        state.getAccountsDetailData.data = action?.payload?.data?.data;
      })
      .addCase(getAccountDetails.rejected, state => {
        state.getAccountsDetailData.loader = false;
        state.getAccountsDetailData.data = [];
      })

      // community user plan change
      .addCase(getUserCommunityPlans.pending, state => {
        state.getUserCommunityPlansData.loader = true;
      })
      .addCase(getUserCommunityPlans.fulfilled, (state, action) => {
        state.getUserCommunityPlansData.loader = false;
        state.getUserCommunityPlansData.data = action?.payload?.data?.data;
      })
      .addCase(getUserCommunityPlans.rejected, state => {
        state.getUserCommunityPlansData.loader = false;
        state.getUserCommunityPlansData.data = [];
      })

      // community user Voip plan change
      .addCase(getUserVoipCommunityPlans.pending, state => {
        state.getUserCommunityVoipPlansData.loader = true;
      })
      .addCase(getUserVoipCommunityPlans.fulfilled, (state, action) => {
        state.getUserCommunityVoipPlansData.loader = false;
        state.getUserCommunityVoipPlansData.data = action?.payload?.data?.data;
      })
      .addCase(getUserVoipCommunityPlans.rejected, state => {
        state.getUserCommunityVoipPlansData.loader = false;
        state.getUserCommunityVoipPlansData.data = [];
      })

      // community user TV plan change
      .addCase(getUserTvCommunityPlans.pending, state => {
        state.getUserCommunityTvPlansData.loader = true;
      })
      .addCase(getUserTvCommunityPlans.fulfilled, (state, action) => {
        state.getUserCommunityTvPlansData.loader = false;
        state.getUserCommunityTvPlansData.data = action?.payload?.data?.data;
      })
      .addCase(getUserTvCommunityPlans.rejected, state => {
        state.getUserCommunityTvPlansData.loader = false;
        state.getUserCommunityTvPlansData.data = [];
      })
      // user plan change
      .addCase(UpdateUserPlanChange.pending, state => {
        state.getUserPlanChangeData.loader = true;
      })
      .addCase(UpdateUserPlanChange.fulfilled, (state, action) => {
        state.getUserPlanChangeData.loader = false;
        state.getUserPlanChangeData.data = action?.payload?.data?.data;
      })
      .addCase(UpdateUserPlanChange.rejected, state => {
        state.getUserPlanChangeData.loader = false;
        state.getUserPlanChangeData.data = [];
      })

      // user plan add-ons changes
      .addCase(UpdateUserPlanAddOns.pending, state => {
        state.getUserPlanAddOnsChangeData.loader = true;
      })
      .addCase(UpdateUserPlanAddOns.fulfilled, (state, action) => {
        state.getUserPlanAddOnsChangeData.loader = false;
        state.getUserPlanAddOnsChangeData.data = action?.payload?.data?.data;
      })
      .addCase(UpdateUserPlanAddOns.rejected, state => {
        state.getUserPlanAddOnsChangeData.loader = false;
        state.getUserPlanAddOnsChangeData.data = [];
      })


      // user accounts by phone number
      .addCase(getAccountDetailsByPhonenumber.pending, state => {
        state.phoneSearchedUserData.loader = true;
      })
      .addCase(getAccountDetailsByPhonenumber.fulfilled, (state, action) => {
        state.phoneSearchedUserData.loader = false;
        state.phoneSearchedUserData.data = action?.payload?.data;
        state.phoneSearchedUserData.error = action?.payload?.data?.["is-success"] ? null : action?.payload?.data?.messages?.[0];
      })
      .addCase(getAccountDetailsByPhonenumber.rejected, state => {
        state.phoneSearchedUserData.loader = false;
        state.phoneSearchedUserData.data = [];
      })


      // user plan change
      .addCase(FiberConnectionDetails.pending, state => {
        state.fiberConnectionDetails.loader = true;
      })
      .addCase(FiberConnectionDetails.fulfilled, (state, action) => {
        state.fiberConnectionDetails.loader = false;
        state.fiberConnectionDetails.data = action?.payload?.data?.data;
        //       {
        //   "oper-status": "present",
        //   "status": "Confirmed",
        //   "up-time": "2054446",
        //   "ip": "100.104.91.181",
        //   "mac": "04:BC:9F:2A:C0:80",
        //   "connection_state": "GOOD",
        //   "alarms": []
        // }
      })
      .addCase(FiberConnectionDetails.rejected, state => {
        state.fiberConnectionDetails.loader = false;
        state.fiberConnectionDetails.data = {};
      })
      .addCase(getinternalUserDeatails.pending, state => {
        state.internalUserDeatails.loader = true;
      })
      .addCase(getinternalUserDeatails.fulfilled, (state, action) => {
        state.internalUserDeatails.loader = false;
        state.internalUserDeatails.data = action?.payload?.data?.data || [];
      })
      .addCase(getinternalUserDeatails.rejected, state => {
        state.internalUserDeatails.loader = false;
      })
  }
});

export const getReduxCurrentPlanData = state => state.userDetailSlice.getCurrentPlanData;
export const getReduxSelectedAccount = state => state.userDetailSlice.SelectedAccount;
export const {
  setUserLoginInfo,
  setUserAccountDetails,
  setSelectedAccount,
  addServiceTickets,
  setViewServiceTicket,
  setSelectedServiceGroupType,
  updateFiberPlanData,
  updateVoipPlanData,
  updateTvPlanData,
  setCentricUser,
  setSelectedAddressAccount,
  setSelectedAddressServiceAccount,
  phoneSearchedUserData,
  updateTempUserData,
  clearErrorMessage
} = userDetailSlice.actions;

export default userDetailSlice.reducer;
